<div class="qr-page" *ngIf="qrDataLoading; else loadedContent">
  <header class="qr-page-header">
    <span class="brand"><mat-icon>bolt</mat-icon>{{ tenantName || 'HubEx' }}</span>
    <div class="lang-selector">
      <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
      <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
      <button class="lang-btn" [class.active]="selectedLanguage === 'fa'" (click)="changeLanguage('fa')">فا</button>
    </div>
  </header>
  <main class="not-found-card">
    <mat-spinner diameter="48"></mat-spinner>
    <h2>{{'qrcode.loading' | translate}}</h2>
  </main>
</div>

<ng-template #loadedContent>
  <div class="qr-page" *ngIf="connectorExists; else notFoundOrLoading">
  <header class="qr-page-header">
    <a class="brand" href="/">
      <img *ngIf="tenantLogo" [src]="tenantLogo" alt="Logo" class="tenant-logo">
      <span *ngIf="!tenantLogo">{{ tenantName || 'HubEx' }}</span>
    </a>
    <div class="header-right">
      <div class="header-context">
        <mat-icon>ev_station</mat-icon>
        <span>{{'qrcode.charging_Station' | translate}}</span>
      </div>
      <div class="lang-selector">
        <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'fa'" (click)="changeLanguage('fa')">فا</button>
      </div>
    </div>
  </header>

  <main class="qr-main">
    <nav class="qr-progress" aria-label="Charging flow progress">
      <div class="progress-step" [class.is-active]="currentStep === 0" [class.is-complete]="currentStep > 0">
        <span class="progress-marker">1</span>
        <span>{{'qrcode.step_contact' | translate}}</span>
      </div>
      <span class="progress-line" [class.is-active]="currentStep > 0"></span>
      <div class="progress-step" [class.is-active]="currentStep === 1" [class.is-complete]="currentStep > 1">
        <span class="progress-marker">2</span>
        <span>{{'qrcode.step_wallet' | translate}}</span>
      </div>
      <span class="progress-line" [class.is-active]="currentStep > 1"></span>
      <div class="progress-step" [class.is-active]="currentStep === 2">
        <span class="progress-marker">3</span>
        <span>{{'qrcode.summary' | translate}}</span>
      </div>
    </nav>

    <mat-horizontal-stepper [linear]="true" #stepper class="qrcode-stepper" (selectionChange)="onStepChange($event)">
      <mat-step [stepControl]="step1Form" label="{{'qrcode.step_contact' | translate}}">
        <form [formGroup]="step1Form" class="step-form compact-form">
          <div class="step-intro">
            <span class="eyebrow">01</span>
            <h1>{{'qrcode.step1_title' | translate}}</h1>
          </div>

          <mat-form-field appearance="outline" class="full-width" *ngIf="!otpSent">
            <mat-label>{{'qrcode.phone' | translate}}</mat-label>
            <input matInput type="tel" formControlName="phone" placeholder="09123456789" autocomplete="tel">
            <mat-icon matSuffix>phone</mat-icon>
            <mat-hint>{{'qrcode.phone_hint' | translate}}</mat-hint>
            <mat-error *ngIf="step1Form.get('phone')?.hasError('required')">{{'qrcode.phone_required' | translate}}</mat-error>
            <mat-error *ngIf="step1Form.get('phone')?.hasError('pattern')">{{'qrcode.phone_invalid' | translate}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width" *ngIf="otpSent">
            <mat-label>{{'qrcode.phone' | translate}}</mat-label>
            <input matInput type="tel" formControlName="phone" readonly>
            <mat-icon matSuffix>phone</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width" *ngIf="otpSent && (otpFlow === 'LOGIN' || otpFlow === 'REGISTRATION')">
            <mat-label>{{'qrcode.otp_code' | translate}}</mat-label>
            <input matInput type="text" formControlName="otp" placeholder="1234" maxlength="4" autocomplete="one-time-code">
            <mat-icon matSuffix>pin</mat-icon>
            <mat-hint>{{'qrcode.otp_hint' | translate}}</mat-hint>
            <mat-error *ngIf="step1Form.get('otp')?.hasError('required')">{{'qrcode.otp_required' | translate}}</mat-error>
            <mat-error *ngIf="step1Form.get('otp')?.hasError('pattern')">{{'qrcode.otp_invalid' | translate}}</mat-error>
          </mat-form-field>

          <div class="step-actions single-action">
            <button mat-flat-button class="primary-action" (click)="nextStep()" [disabled]="step1Form.invalid || isSendingOTP || isVerifyingOTP">
              <mat-spinner diameter="20" *ngIf="isSendingOTP || isVerifyingOTP"></mat-spinner>
              <span *ngIf="!isSendingOTP && !isVerifyingOTP && !otpSent">{{'qrcode.send_otp' | translate}}</span>
              <span *ngIf="!isSendingOTP && !isVerifyingOTP && otpSent">{{'qrcode.verify_otp' | translate}}</span>
              <mat-icon *ngIf="!isSendingOTP && !isVerifyingOTP">arrow_forward</mat-icon>
            </button>
          </div>

          <p class="field-label-above">{{'qrcode.step1_desc' | translate}}</p>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{'qrcode.email' | translate}} ({{'qrcode.optional' | translate}})</mat-label>
            <input matInput type="email" formControlName="email" placeholder="name@mail.com" autocomplete="email" [readonly]="otpSent">
            <mat-icon matSuffix>email</mat-icon>
            <mat-error *ngIf="step1Form.get('email')?.hasError('email')">{{'qrcode.email_invalid' | translate}}</mat-error>
          </mat-form-field>

          <article class="location-info-step1" *ngIf="chargingStation">
            <div class="location-row">
              <mat-icon>location_on</mat-icon>
              <div class="location-details">
                <div *ngIf="chargingStation?.id"><span class="location-label">{{'qrcode.station' | translate}} :</span> <strong>{{ chargingStation.id }}</strong></div>
                <div *ngIf="chargingStation?.site?.name"><span class="location-label">{{'qrcode.site_name' | translate}} :</span> <strong>{{ chargingStation.site.name }}</strong></div>
                <div *ngIf="chargingStation?.siteArea?.name"><span class="location-label">{{'qrcode.zone' | translate}} :</span> <strong>{{ chargingStation.siteArea.name }}</strong></div>
                <div *ngIf="siteAddress"><span class="location-label">{{'qrcode.site_address' | translate}} :</span> <strong>{{ siteAddress }}</strong></div>
              </div>
            </div>
          </article>

          <article class="connector-info-step1" *ngIf="connectorStatus">
            <div class="connector-row">
              <span class="connector-label">{{'qrcode.connector' | translate}} {{ connectorId }}</span>
              <span class="connector-badge" [ngStyle]="{'background-color': connectorStatusColor}">{{ connectorStatus }}</span>
            </div>
          </article>

          <article class="pricing-card step1-pricing" *ngIf="pricingDefinitions">
            <div class="card-title"><mat-icon>receipt_long</mat-icon><h2>{{'qrcode.pricing_breakdown' | translate}}</h2></div>
            <div class="pricing-row" *ngIf="hasFlatFee"><span>{{'qrcode.FlatFee' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.flatFee.price) }} {{'qrcode.currency_irr' | translate}}</strong></div>
            <div class="pricing-row" *ngIf="hasEnergy"><span>{{'qrcode.Energy' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.energy.price) }} {{'qrcode.currency_irr' | translate}}/kWh</strong></div>
            <div class="pricing-row" *ngIf="hasChargingTime"><span>{{'qrcode.ChargingTime' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.chargingTime.price) }} {{'qrcode.currency_irr' | translate}}/h</strong></div>
            <div class="pricing-row" *ngIf="hasParkingTime"><span>{{'qrcode.Parkingtime' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.parkingTime.price) }} {{'qrcode.currency_irr' | translate}}/h</strong></div>
          </article>
        </form>
      </mat-step>

      <mat-step [stepControl]="step2Form" label="{{'qrcode.step_wallet' | translate}}">
        <form [formGroup]="step2Form" class="step-form compact-form">
          <div class="step-intro">
            <span class="eyebrow">02</span>
            <h1>{{'qrcode.step2_wallet_title' | translate}}</h1>
            <p>{{'qrcode.step2_wallet_desc' | translate}}</p>
          </div>

          <div class="wallet-current" *ngIf="currentWalletBalance > 0">
            <mat-icon>account_balance_wallet</mat-icon>
            <span>{{'qrcode.wallet_current_balance' | translate}}</span>
            <strong>{{ formatIRR(currentWalletBalance) }} {{'qrcode.currency_irr' | translate}}</strong>
          </div>

          <div class="wallet-min-alert" *ngIf="currentWalletBalance < minimumWalletBalance">
            <mat-icon>warning_amber</mat-icon>
            <span>{{ walletRequiredTopUpMessage }}</span>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{'qrcode.credit_amount' | translate}}</mat-label>
            <input matInput type="number" formControlName="creditAmount" placeholder="100000" [min]="requiredTopUp" max="500000000" step="10">
            <span matSuffix>{{'qrcode.currency_irr' | translate}}</span>
            <mat-error *ngIf="step2Form.get('creditAmount')?.hasError('required')">{{'qrcode.amount_required' | translate}}</mat-error>
            <mat-error *ngIf="step2Form.get('creditAmount')?.hasError('min')">{{'qrcode.amount_min' | translate}}</mat-error>
          </mat-form-field>
          <div class="amount-formatted" *ngIf="step2Form.get('creditAmount')?.value">
            {{ formatIRR(step2Form.get('creditAmount')?.value || 0) }} {{'qrcode.currency_irr' | translate}}
          </div>

          <div class="quick-amounts">
            <span class="field-label">{{'qrcode.quick_amounts' | translate}}</span>
            <div class="amount-buttons">
              <button mat-button type="button" *ngFor="let amount of quickAmounts" (click)="setQuickAmount(amount)" [class.selected]="step2Form.get('creditAmount')?.value === amount">
                {{formatIRR(amount)}} {{'qrcode.currency_irr' | translate}}
              </button>
            </div>
          </div>

          <div class="wallet-preview" *ngIf="step2Form.get('creditAmount')?.valid">
            <span>{{'qrcode.wallet_balance_after' | translate}}</span>
            <strong>{{ formatIRR(currentWalletBalance + (step2Form.get('creditAmount')?.value || 0)) }} {{'qrcode.currency_irr' | translate}}</strong>
          </div>

          <div class="step-actions">
            <button mat-button type="button" (click)="prevStep()">{{'qrcode.back' | translate}}</button>
            <button mat-flat-button class="primary-action" type="button" (click)="nextStep()" [disabled]="step2Form.invalid && currentWalletBalance < minimumWalletBalance">
              {{'qrcode.next' | translate}} <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="step3Form" label="{{'qrcode.summary' | translate}}">
        <form [formGroup]="step3Form" class="payment-step">
          <div class="payment-layout">
            <section class="payment-details">
              <div class="step-intro">
                <span class="eyebrow">03</span>
                <h1>{{ (requiresWalletTopUp ? 'qrcode.step3_resume_title' : 'qrcode.wallet_ready_title') | translate }}</h1>
                <p>{{ (requiresWalletTopUp ? 'qrcode.step3_resume_desc' : 'qrcode.wallet_ready_desc') | translate }}</p>
              </div>

              <article class="station-card">
                <div class="card-title"><mat-icon>ev_station</mat-icon><h2>{{'qrcode.charging_details' | translate}}</h2></div>
                <div class="station-grid">
                  <div><span>{{'qrcode.site_name' | translate}}</span><strong>{{ siteName || '-' }}</strong></div>
                  <div><span>{{'qrcode.station' | translate}}</span><strong>{{ chargingStation?.id || '-' }}</strong></div>
                  <div class="station-address"><span>{{'qrcode.site_address' | translate}}</span><strong><mat-icon>location_on</mat-icon>{{ siteAddress || '-' }}</strong></div>
                  <div class="connector-summary">
                    <span class="connector-icon"><mat-icon>bolt</mat-icon></span>
                    <div><span>{{'qrcode.connector' | translate}} {{ connectorId }}</span><strong>{{ connectorTypeLabel || '-' }}</strong></div>
                    <em [ngStyle]="{'color': connectorStatusColor}">{{ connectorStatus || '-' }}</em>
                  </div>
                </div>
              </article>

              <article class="pricing-card" *ngIf="pricingDefinitions">
                <div class="card-title"><mat-icon>receipt_long</mat-icon><h2>{{'qrcode.pricing_breakdown' | translate}}</h2></div>
                <div class="pricing-row" *ngIf="hasFlatFee"><span>{{'qrcode.FlatFee' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.flatFee.price) }} {{'qrcode.currency_irr' | translate}}</strong></div>
                <div class="pricing-row" *ngIf="hasEnergy"><span>{{'qrcode.Energy' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.energy.price) }} {{'qrcode.currency_irr' | translate}}/kWh</strong></div>
                <div class="pricing-row" *ngIf="hasChargingTime"><span>{{'qrcode.ChargingTime' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.chargingTime.price) }} {{'qrcode.currency_irr' | translate}}/h</strong></div>
                <div class="pricing-row" *ngIf="hasParkingTime"><span>{{'qrcode.Parkingtime' | translate}}</span><strong>{{ roundPrice(pricingDefinitions.dimensions.parkingTime.price) }} {{'qrcode.currency_irr' | translate}}/h</strong></div>
              </article>
            </section>

            <aside class="wallet-payment-card">
              <mat-icon class="wallet-watermark">account_balance_wallet</mat-icon>
              <span class="wallet-label">{{ (requiresWalletTopUp ? 'qrcode.payment_method' : 'qrcode.wallet_current_balance') | translate }}</span>
              <div class="wallet-method"><mat-icon>account_balance_wallet</mat-icon><strong>{{ getPaymentMethodLabel() }}</strong></div>
              <span class="wallet-label">{{ (requiresWalletTopUp ? 'qrcode.wallet_credit' : 'qrcode.wallet_current_balance') | translate }}</span>
              <div class="wallet-balance">{{ formatIRR(requiresWalletTopUp ? (step2Form?.get('creditAmount')?.value || 0) : currentWalletBalance) }} <small>{{'qrcode.currency_irr' | translate}}</small></div>
              <div class="wallet-sufficient" *ngIf="!requiresWalletTopUp"><mat-icon>check_circle</mat-icon>{{'qrcode.wallet_sufficient' | translate}}</div>
              <button mat-flat-button class="pay-action" type="button" (click)="startSession()" [disabled]="isProcessing || isRedirectingToTamin">
                <mat-spinner diameter="20" *ngIf="isProcessing || isRedirectingToTamin"></mat-spinner>
                <span *ngIf="!isProcessing && !isRedirectingToTamin">{{ (requiresWalletTopUp ? 'qrcode.pay' : 'qrcode.continue_to_charging') | translate }}</span>
                <mat-icon *ngIf="!isProcessing && !isRedirectingToTamin">{{ requiresWalletTopUp ? 'play_circle' : 'arrow_forward' }}</mat-icon>
              </button>
              <button mat-button type="button" class="back-link" (click)="prevStep()" [disabled]="isProcessing || isRedirectingToTamin">{{'qrcode.back' | translate}}</button>
            </aside>
          </div>

          <div class="tamin-notice" *ngIf="isRedirectingToTamin"><mat-icon>info</mat-icon><span>{{'qrcode.redirecting_tamin' | translate}}</span></div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
  </main>
</div>
</ng-template>

<ng-template #notFoundOrLoading>
  <div class="qr-page" *ngIf="stationLoaded; else stationLoading">
    <div class="qr-page not-found-page">
      <header class="qr-page-header">
        <span class="brand"><mat-icon>bolt</mat-icon>{{ tenantName || 'HubEx' }}</span>
        <div class="lang-selector">
          <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
          <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
          <button class="lang-btn" [class.active]="selectedLanguage === 'fa'" (click)="changeLanguage('fa')">فا</button>
        </div>
      </header>
      <main class="not-found-card"><mat-icon>error_outline</mat-icon><h1>{{'qrcode.ConnectorNotFound' | translate}}</h1><p>{{'qrcode.call_or_message' | translate}}</p></main>
    </div>
  </div>
</ng-template>

<ng-template #stationLoading>
  <div class="qr-page">
    <header class="qr-page-header">
      <span class="brand"><mat-icon>bolt</mat-icon>{{ tenantName || 'HubEx' }}</span>
      <div class="lang-selector">
        <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'fa'" (click)="changeLanguage('fa')">فا</button>
      </div>
    </header>
    <main class="not-found-card">
      <mat-spinner diameter="48"></mat-spinner>
      <h2>{{'qrcode.loading' | translate}}</h2>
    </main>
  </div>
</ng-template>
